"use server";

import { redirect } from "@solidjs/router";
import { serverRepo } from "~/server/apis/server_repo";
import { CategoryResult } from "~/server/types/category";
import { Product } from "~/server/types/search";
import { OfferConstruct } from "~/server/types/brand";
import { isOfferAvailed } from "~/core/offer-construct/offer-construct";

export type HomeTataRouteData = {
  categories: CategoryResult;
  brands: Product[];
  offerConstruct?: OfferConstruct;
};

export async function getHomeTataRouteData(): Promise<HomeTataRouteData> {
  const [categories, allBrands, offerConstruct] = await Promise.all([
    serverRepo.getCategories(),
    serverRepo.getProductSearch({ query: "" }),
    serverRepo.getOfferConstruct(),
  ]);

  if (offerConstruct && isOfferAvailed(offerConstruct)) {
    throw redirect("/profile");
  }

  const brands =
    allBrands?.data?.[0]?.products?.filter(
      (product) => product.voucherProduct.status === "ACTIVE"
    ) || [];

  return {
    categories,
    brands,
    offerConstruct,
  };
}
